export * from './scroll';
/**
 * clear node clearing
 * @param node
 * @internal
 */
export function clear(node) {
    while (node.lastChild) {
        node.removeChild(node.lastChild);
    }
    return node;
}
//# sourceMappingURL=index.js.map